<template>

<div class="settings_right">
  <div class="questionnarie_form_wrap">
    <div class="questionnarie_form">
      <div class="questionnarie_title" v-if="petitionConfigList.length > 0">
        <ul>
          <li v-for="( conf ,index ) in petitionConfigList" :key="index">


          
          <a :class="{'active':index==selectedMainTypeIndex}" @click="changedType('main');selectedMainTypeIndex=index ;selectedSubTypeIndex=0 ; selectToConfig(petitionConfigList[selectedMainTypeIndex]  ,'FORMS_LETTERS' ,null)" >
          
          {{conf.name}}

          <div class="table_switch mb-0 ml-4" v-if="index==selectedMainTypeIndex"> 

            <vs-switch class="mb-0" @input="caseSelectionChanged(conf ,false)"  v-model="conf.isCaseTypeSelected">
            <span slot="on">Yes</span>
            <span slot="off">No</span>
            </vs-switch>
          </div>
          

       
          
          </a></li>
         
        </ul>
      </div>  
      <div class="questionnarie_form_cnt"  v-if="petitionConfigList[selectedMainTypeIndex] && petitionConfigList[selectedMainTypeIndex].subTypes.length>0"> 
        <div class="subtypes_list">
          <div class="questionnarie_actions">
                <button v-if="  checkProperty(caseType ,'id') !=3" :disabled="checkProperty(petitionConfigList[selectedMainTypeIndex] ,'isCaseTypeSelected') ==false" class="primary-btn" @click="selectWorkFlowConfig();selectToConfig(petitionConfigList[selectedMainTypeIndex]  ,'WORK_FLOW')"> 
                  Change Workflow 
                  
                </button>
                <!--<button class="primary-btn" @click="selectToConfig(petitionConfigList[selectedMainTypeIndex]  ,'QUESTIONNAIRE_TEMPLATE')">Change Questionnaire</button>-->  
          </div>

          
           
                  <ul >
            <li  v-for="(  subType ,subindex ) in petitionConfigList[selectedMainTypeIndex].subTypes" :key="subindex" @click="selectWorkFlowConfig();changedType('sub');selectedSubTypeIndex =subindex; selectToConfig(petitionConfigList[selectedMainTypeIndex]  ,'FORMS_LETTERS' ,subType )" >
            <a :class="{'activetype':selectedSubTypeIndex==subindex}" >
               <span>{{subType.name}}</span>
               
              <div class="table_switch mb-0 ml-4"> 

                <vs-switch class="mb-0"  :disabled="checkProperty(petitionConfigList[selectedMainTypeIndex] ,'isCaseTypeSelected') ==false" @input="caseSelectionChanged(subType  ,true)"  v-model="subType.isCaseTypeSelected">
                    <span slot="on">Yes </span>
                    <span slot="off">No</span>
                </vs-switch>
              </div>
              </a>
            </li>
            
          </ul>
        </div>
        <div class="subtypes_content pt-0">
 
          <div class="v-modal"> 
            <div   class="form-container pt-4"> 
                <div class="d-flex justify-center">
              <button v-if="  checkProperty(caseType ,'id')==3" :disabled="checkProperty(petitionConfigList[selectedMainTypeIndex] ,'isCaseTypeSelected') ==false" class="primary-btn primary-btn-top" @click="selectToConfig(petitionConfigList[selectedMainTypeIndex]  ,'WORK_FLOW')"> 
                  Change Workflow 
                  
                </button>

            <button class="primary-btn primary-btn-top" :disabled="checkProperty(petitionConfigList[selectedMainTypeIndex] ,'isCaseTypeSelected') ==false || checkProperty(caseSubType,'isCaseTypeSelected' ) ==false" @click="selectToConfig(petitionConfigList[selectedMainTypeIndex]  ,'QUESTIONNAIRE_TEMPLATE')">Change Questionnaire </button> 
            </div>
            <div class="config_title subtype_title">
            
              <h2 class="form__title case-text-break">{{checkProperty(caseSubType ,'name')}} 
                
                <template v-if="checkProperty(caseSubType ,'id') ==15">Audit Response Letters</template>
                <template v-else>Forms and Letters</template>
              </h2>
              <template @click="errorMessage=''" v-if="formsAndLettersList && formsAndLettersList.length > 0" >
                <!---this.checkProperty(this.caseSubType,'configDetails' ,'questionnaireTplId')-->
                <vs-button  class="save primary-btn" :disabled="formSubmited || checkProperty(petitionConfigList[selectedMainTypeIndex] ,'isCaseTypeSelected') ==false || checkProperty(caseSubType,'isCaseTypeSelected' ) ==false"   @click="configType='FORMS_LETTERS' ;opdateOrCreateFormsANdLetters()">{{editConfiguration?'Update':'Update'}}</vs-button>
              </template>
            </div>
            <!---
            <template v-if=" (checkProperty(caseSubType ,'id') ==15 && checkProperty(caseType ,'id')==3 )">
              
              <div class="no-data" >Forms and Letters are not required</div>
            
            </template>
          -->
            <template >
              <template v-if="formsAndLettersList && formsAndLettersList.length > 0" >
               <ul>
              <template v-for="( form , index) in formsAndLettersList" > 
                
                 <template v-if=" checkProperty(caseSubType ,'id') ==15 && form['type']=='audit_response' ">
                  <li :key="index">
                      <div class="form_group">   
                        <vs-checkbox :disabled="checkProperty(petitionConfigList[selectedMainTypeIndex] ,'isCaseTypeSelected') ==false || checkProperty(caseSubType,'isCaseTypeSelected' ) ==false" v-model="form.selected" >
                          {{form.name}}
                          <small v-if="!checkProperty( form ,'tenantId')">(Global)</small>
                        </vs-checkbox>
                        <a @click="downloadFile(form.document)"  href.prevent class="primary-btn download_btn" >Download</a>
                      </div>
                  </li> 
                </template>
                <template v-if="checkProperty(caseSubType ,'id') !=15 && form['type'] !='audit_response' ">
                  
                  <li :key="index">
                      <div class="form_group">   
                        <vs-checkbox :disabled="checkProperty(petitionConfigList[selectedMainTypeIndex] ,'isCaseTypeSelected') ==false || checkProperty(caseSubType,'isCaseTypeSelected' ) ==false" v-model="form.selected" >
                          {{form.name}}
                          <small v-if="!checkProperty( form ,'tenantId')">(Global)</small>
                        </vs-checkbox>
                        <a @click="downloadFile(form.document)"  href.prevent class="primary-btn download_btn" >Download</a>
                      </div>
                  </li> 
                </template>
              </template>
              </ul>
              </template>            
            <template v-else >
                <div class="no-data" >No Data Available</div>
            </template>
              
            </template>            
           
            
                    <div class="text-danger text-sm formerrors" v-if="'FORMS_LETTERS'==configType" v-show="errorMessage" @click="errorMessage=''">
                  <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                    icon="IP-information-button" active="true">{{ errorMessage }}</vs-alert>
                </div>
            </div> 
            <!-- <div class="popup-footer"  @click="errorMessage=''" v-if="formsAndLettersList && formsAndLettersList.length > 0"  >
              
              <vs-button class="save primary-btn" :disabled="formSubmited"   @click="configType='FORMS_LETTERS' ;opdateOrCreateFormsANdLetters()">{{editConfiguration?'Change':'Create'}}</vs-button>
          
            </div> -->
      
          </div>
          <span class="loader" v-if="subtypeloader"><img src="@/assets/images/main/loader.gif"></span>
        </div>
        <span class="loader" v-if="maintypeloader"><img src="@/assets/images/main/loader.gif"></span>
      </div>
      <div v-else class="no-data" ></div> 
    </div>
  </div>
  
 

  
<div class="change_workflow_quest">
  <modal 
     
    name="petition-workflow-configuration" 
    classes="v-modal-sec"
    :min-width="200"
    :min-height="200"
    :scrollable="true"
    :reset="true"
    width="500px"
    height="auto">
    <!-- formsAndLettersList  <span class="im_overlay" @click="$modal.hide('petition-workflow-configuration'); configPopup=false;"></span> -->
    <div class="v-modal ">
       
      <div class="popup-header">
        <h2 class="popup-title">{{modalTitle}}</h2>
        <span @click="hideModel()">
          <em class="material-icons">close</em>
        </span>
      </div>
     <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0" :settings="settings">
       <div   class="form-container workflow-configuration-model"> 

           <template v-if="'QUESTIONNAIRE_TEMPLATE'==configType && questionnaireTemplatsList.length == 1">
                       <vs-alert color="primary" class="success-alerts-wrap no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                   <p> You have one Questionnaire available at the moment, if you need a new Questionnaire contact ImmiBox support team</p>
                                </vs-alert>


         </template>

           <template v-if="'WORK_FLOW'==configType && workFlowList.length == 1">
                       <vs-alert v-if="false" color="primary" class="success-alerts-wrap no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                   <p> Add a new Workflow to change Workflow for this case type</p>
                                </vs-alert>


         </template>

       <template v-if="'QUESTIONNAIRE_TEMPLATE'==configType">
       
       <template v-for="( tpl , index) in questionnaireTemplatsList" >  
          <div :key="index" class="vx-row"  > 
                
            <div class="vx-col w-full">
                <div class="form_group">   
                  <div class="radio_sec w-full">
                    <vs-radio @input="templateSelected(tpl._id)" v-model="tpl.selected" vs-name="radios1" :vs-value="true">{{tpl.name}}</vs-radio>
                    <a class="primary-btn relative overflow-hidden" @click="selectedItem = tpl;showQuesview=true">
                      <!--<figure  v-if="checkProperty(tpl ,'showLoading')" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>-->
                      Preview</a>      
                  </div>
                </div>
            </div> 
          </div>
         </template>
       </template>
       <template v-if="'WORK_FLOW'==configType">
        <template v-for="( tpl , index) in workFlowList" >  
          <div :key="index" class="vx-row"  > 
                
            <div class="vx-col w-full">
                <div class="form_group">   
                  <div class="radio_sec w-full" >    
                    <div class="form_radio_btns">               
                      <vs-radio @input="workFlowSelected(tpl._id)" v-model="tpl.selected" vs-name="radios1" :vs-value="true">{{tpl.name}}</vs-radio>
                    </div>
                    <a class="primary-btn relative overflow-hidden" @click="loadWorkflowPopup(tpl)">
                    <figure v-if="checkProperty(tpl ,'showLoading')"  class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
                    Preview</a>
                   
                  </div>
                </div>
            </div> 
          </div>
         </template>
       </template>
       <template v-if="'FORMS_LETTERS'==configType">
        <template v-for="( form , index) in formsAndLettersList" >  
          <div :key="index" class="vx-row"  > 
                
            <div class="vx-col w-full">
                <div class="form_group">   
                  <div class="con-select w-full" >
                    <vs-checkbox v-model="form.selected" >{{form.name}}</vs-checkbox>
                  </div>
                  <a @click="downloadFile(form.document)"  href.prevent class="primary-btn download_btn" >Download</a>
                </div>
            </div>

            <!-- <div class="vx-col md:w-1/2 w-full">
                <div class="form_group">   
                <div class="con-select w-full" >
                                  
                    
                    </div>
                </div>
            </div> -->
          </div>
         </template>
       </template>
      
              <div class="text-danger text-sm formerrors mt-5" v-show="errorMessage" @click="errorMessage=''">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ errorMessage }}</vs-alert>
          </div>
          
      </div> 
    </VuePerfectScrollbar>
   <!--   {{caseSubType}}-->
      
      <div class="popup-footer" v-if="('WORK_FLOW'==configType ) || ('QUESTIONNAIRE_TEMPLATE'==configType ) "  @click="errorMessage=''" >
        <vs-button class="cancel" @click="hideModel();">Cancel</vs-button>
       <!-----v-if='checkButtonsEnable'-->
        <template  >
      
        <vs-button class="save" :disabled="formSubmited" v-if="'QUESTIONNAIRE_TEMPLATE'==configType "  @click="updaQtemplate()">{{editConfiguration?'Change':'Change'}}</vs-button>
         <vs-button class="save" :disabled="formSubmited" v-if="'WORK_FLOW'==configType"  @click="workFlowconfigAction()">{{editConfiguration?'Change':'Change'}}</vs-button>
        <vs-button class="save" :disabled="formSubmited" v-if="'FORMS_LETTERS'==configType"  @click="opdateOrCreateFormsANdLetters()">{{editConfiguration?'Change':'Change'}}</vs-button>
        </template>
      </div>
     
    </div>
    </modal>
  </div>


    <div
      v-if="workflowDetailsData"
      class="workflow_view_wrap"
      :class="{ listopen: showWorkflowview }"
      style="z-index:9999999"
    >
      <div class="workflow_overlay" @click="showWorkflowview = false"></div>
      <div class="workflow_view_cnt">
        <div
          class="workflow_view_title view__title"
          :class="{ 'pr-0': showWorkflowview }"
        > <div>
          <label>{{ checkProperty(workflowDetailsData, "name") }}</label>
          </div>
          <span @click="showWorkflowview = false">
            <x-icon size="1.5x" class="custom-class"></x-icon>
          </span>
        </div>

        <div class="workflow_view_sec" >
          <!-- <template slot="thead">
                    <vs-th> Activity </vs-th>
                    <vs-th>Editors</vs-th>
                    <vs-th>Watchers </vs-th>
                </template> -->
          <div class="workflow_view_head">
            <ul>
              <li class="activity">Activity</li>
              <li class="editors">Editors</li>
              <li class="watchers">Watchers</li>
            </ul>
          </div>

          <template>
            <div class="workflow_view_body">
             
              <template v-for="(tr, indextr) in activityList">
                
                
                 <workflowActivityView
                  :key="indextr"
                  :activityList="activityList"
                  :item="tr"
                  :currentIndex="indextr"
                />
              
              </template>
            
            </div>
          </template>
        </div>
      </div>
    </div>





  <div  class="workflow_view_wrap" v-if="showQuesview" :class="{ listopen: showQuesview }" style="z-index:9999999">
    <div class="workflow_overlay" @click="showQuesview = false"></div>
    <div class="workflow_view_cnt questionary_cnt questionaryviewwrap" style="width: 90%;">
      <div class="workflow_view_title" :class="{'pr-0' :type=='view'}">
      
       <!-- <label> Questionnaire Template </label>-->
        <label v-if="checkProperty(selectedItem ,'name')">{{checkProperty(selectedItem ,'name')}}  </label>

    <span @click="showQuesview = false">
            <x-icon size="1.5x" class="custom-class"></x-icon>
          </span>
      </div>
      <template >
           
              <template v-if="checkProperty(selectedItem, 'entityType') == 'perm'" >
                <PermQuestionnaireTemplate
                  @gotoList="gotoList" :isEdit="false"
                  :templateId="checkProperty(selectedItem, '_id')"
                />
              </template>
              <template v-if="['case','I-130', 'L-VISA'].indexOf(checkProperty(selectedItem, 'entityType')) >-1" >
                <!-----v-if="checkProperty(selectedItem, 'entityType') == 'case'"-->
                <QuestionnaireTemplate
                  @gotoList="gotoList" :isEdit="false"
                  :templateId="checkProperty(selectedItem, '_id')"
              />
            </template>
            <template v-if="[ 'h4-ead', 'l2' ].indexOf(checkProperty(selectedItem, 'entityType')) >-1" >
                <!-----v-if="checkProperty(selectedItem, 'entityType') == 'case'"-->
                <h4eadQuestionnaireTpl
                  @gotoList="gotoList" :isEdit="false" :entityType="checkProperty(selectedItem, 'entityType')"
                  :templateId="checkProperty(selectedItem, '_id')"
              />
            </template>
          </template>
  
    </div>
  </div>

  <vs-popup style="z-index:99999999; !important" class="holamundo main-popup"  title="Configuration is already linked with Case(s)" :active.sync="updateOrCreateFormsLattersPopup">
      <div class="form-container">
        
        <div class="vx-row">
          <div class="vx-col w-full">
          <p>{{selectionMessage}} </p>
            
          </div>
          
        </div>

         <div v-show="errorMessage">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ errorMessage}}</vs-alert>
          </div>
       
      </div>
      <div class="popup-footer">
        <vs-button color="dark" class="cancel" type="filled" @click="updateOrCreateFormsLattersPopup=false">Cancel </vs-button>
        <template v-if="fromFromsAndLatters">   
            <vs-button color="success"  :disabled="formSubmited"  class="save w-auto" type="filled" @click="opdateOrCreateFormsANdLetters('update')">Update Existing</vs-button>
             <vs-button color="success" :disabled="formSubmited"  class="save w-auto" type="filled" @click="opdateOrCreateFormsANdLetters('create')">Create New</vs-button>
        </template>
        <template v-else>
        

         <vs-button color="success" :disabled="formSubmited" class="save w-auto" type="filled" @click="updaQtemplate('update')">Update Existing</vs-button>
         <vs-button color="success" :disabled="formSubmited"  class="save w-auto" type="filled" @click="updaQtemplate('create')">Create New</vs-button>
       
        
        </template>
      </div>
  </vs-popup>


</div>
     
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker-inv";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import FileUpload from "vue-upload-component/src";
import * as _ from "lodash";
import { InfoIcon } from 'vue-feather-icons'
import { MoreVerticalIcon } from 'vue-feather-icons'
import workflowActivityView from "./workflowActivityView.vue";
import { XIcon } from "vue-feather-icons";

import QuestionnaireTemplate from "@/views/Questionnaire/QuestionnaireTemplate.vue";
import PermQuestionnaireTemplate from "@/views/Questionnaire/PermQuestionnaireTemplate.vue";
import h4eadQuestionnaireTpl from "@/views/Questionnaire/h4eadQuestionnaireTpl.vue";

import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "the-navbar",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      settings: {
      swipeEasing: true,
    },
      //common Veriables
      selectedItem:null,
      showQuesview:false,
      showWorkflowview:false,
      workFlowloading:false,
      formSubmited:false,
      petitionConfigList:[],
      selectedMainTypeIndex:0,
      selectedSubTypeIndex:0,
      caseType:null,
      caseSubType:null,
      configType:'',
      showPopUp:false,
      modalTitle:"Case Configuration",
      errorMessage:'',
      maintypeloader:false,
      subtypeloader:false,

     //QUESTIONNAIRE_TEMPLATE veriables
      questionnaireTemplatsList:[],
      editConfiguration:false,
      configId:null,

      //FORMS_LETTERS veriables
      formsAndLettersList:[],

      //WORK_FLOW veriables
      workFlowList:[], 
      tempworkFlowList:[],
      selectedWorkFlow:null,
      activityList: [],
      LocalActivityList:[],
      workflowDetailsData:null,
      workflowDetails:null,
      workFlowName:null,

      updateOrCreateFormsLattersPopup:false,
      selectionMessage:'',
      fromFromsAndLatters:false,
    };
  },
  watch: {
  },
  mounted() {
    this.getPetitionConfigList();

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    
  },
  computed: {
    checkButtonsEnable(){
     let returnValue =true;
     //v-if="('WORK_FLOW'==configType ) || ('QUESTIONNAIRE_TEMPLATE'==configType )" 
     if('WORK_FLOW'== this.configType && this.workFlowList.length>0  ){

       if(this.workFlowList.length==1){
         if( this.checkProperty(this.workFlowList[0] ,'selected' )){
           returnValue =false

         }

       }

     }else if('QUESTIONNAIRE_TEMPLATE'==this.configType && this.questionnaireTemplatsList.length>0 ){
       //questionnaireTemplatsList
       if(this.questionnaireTemplatsList.length==1){
         if( this.checkProperty(this.questionnaireTemplatsList[0] ,'selected' )){
           returnValue =false

         }

       }
       
     }

     return returnValue;
    }
  },
  methods: {
    caseSelectionChanged(caseItem ,isSubType=false){

      let path="/petition-config/manage-case-types";
      if(isSubType){
        path ="/petition-config/manage-case-sub-types";
      }
      let postData ={

        selList:[],

      };
    let itm=  {
      "id": null,
      "selected": null // Send 'false' to disable
   }

  itm['id'] = caseItem['id']
  itm['selected'] = caseItem['isCaseTypeSelected']
   itm['isCaseTypeSelected'] = caseItem['isCaseTypeSelected']

   postData['selList'].push(itm);

      this.$store
        .dispatch("commonAction", {
          data: postData,
          path: path,
        })
        .then((response) => {
          //alert(JSON.stringify(response));
            this.showToster({message:response.message ,isError:false});
            if(!isSubType){
              
              this.getPetitionConfigList(this.selectedMainTypeIndex);             
              
            }
        }).catch((err) => {
          this.showToster({message:err ,isError:true});
        })




    },
    
    getActivityList() {
      this.$store
        .dispatch("getActivityCodes")
        .then((response) => {
          this.LocalActivityList = response;
        })
        .catch((error) => {});
    },
    getworkflowDetails(workflowId ,item) {
   
      this.getActivityList();
      let postData = {
        workflowId: workflowId,
      };
       this.workFlowloading =true;
      this.$store
        .dispatch("commonAction", {
          data: postData,
          path: "/workflow/details",
        })
        .then((response) => {
         // alert(JSON.stringify(response));
          if (response) {
            this.workflowDetailsData = response;

            this.workFlowName = response["name"];
            this.workflowDetails = response["config"];
            let tempActivityList = [];
            //LocalActivityList
                        _.forEach(response["config"], (dbData) => {

            dbData['showError'] = false;
            let localActivity = _.find(this.LocalActivityList, {  code: dbData["code"] });

            //"step":1, showMe:true, optional:true, showError:false
            if(localActivity){
                if(_.has(localActivity ,'step')){
                  dbData['step'] = localActivity['step']
                }else{
                  dbData['step'] = 2;

                }

                if(_.has(localActivity ,'showMe')){
                  dbData['showMe'] = localActivity['showMe']
                }else{
                  dbData['showMe'] = true;

                }

                if(_.has(localActivity ,'optional')){
                  dbData['optional'] = localActivity['optional']
                }else{
                  dbData['optional'] = false;

                }
                if(_.has(localActivity ,'canAssignAllUsersVal')){
                  dbData['canAssignAllUsersVal'] = localActivity['canAssignAllUsersVal']
                }

                if(_.has(localActivity ,'canAssignAllUsers')){
                  dbData['canAssignAllUsers'] = localActivity['canAssignAllUsers']
                }

              
                //

                              

            }else{

              dbData['step'] = 2;
              dbData['showMe'] = true;
              dbData['optional'] = false;
              dbData['showError'] = false;
              

            }

              
            if(dbData["include"] =="Yes"){
                dbData["include"] =true;
              }else{
                dbData["include"] =false;
              }
              if(dbData["actionRequired"] =="Yes"){
                dbData["actionRequired"] =true;
              }else{
                dbData["actionRequired"] =false;
              }
              
              if( dbData["code"] == 'ASSIGN_SUPERVISOR'){
                dbData["include"] = true;
                dbData["actionRequired"] = true;

              }
              tempActivityList.push(dbData);

            });
            this.activityList = [];
            this.activityList = tempActivityList;
          
             this.showWorkflowview = true;
            this.workFlowloading =false;
            if( this.checkProperty(item  ,'showLoading')){
              item['showLoading'] =false;  
            }
           

          }
        })
        .catch((error) => {
          if( this.checkProperty(item  ,'showLoading')){
              item['showLoading'] =false;  
            }
          this.workFlowloading =false;
          this.showToster({
            message: error,
            isError: true,
          });
        });
    },
    loadWorkflowPopup(workflowItem){
      workflowItem['showLoading'] =true;   
      this.getworkflowDetails(workflowItem._id ,workflowItem)
    },
    hideModel(){
       this.caseType =null;
      this.caseSubType = null;
      this.configType = '';
      this.showPopUp = false;
      this.formSubmited =false
      this.editConfiguration = false;
      this.configId =null;
       this.errorMessage = '';
       this.configType="FORMS_LETTERS";
       this.selectToConfig(null ,"FORMS_LETTERS" ,null );
      this.$modal.hide('petition-workflow-configuration');

    },
    selectToConfig(caseType=''  ,type='' ,subCaseType=null){
     
   
      
      caseType = this.petitionConfigList[this.selectedMainTypeIndex];
      if(this.checkProperty(caseType ,"subTypes")  &&  caseType['subTypes'].length>0 ){
        subCaseType = caseType['subTypes'][this.selectedSubTypeIndex];

      }
      
     //  alert(JSON.stringify(caseType));

      this.modalTitle ="Case Type configuration";  
      this.caseType =caseType;
      this.caseSubType = subCaseType;
      this.configType = type;
      this.showPopUp = true;
      this.configId =null;
      this.editConfiguration =false;
      this.errorMessage = '';
      this.selectedWorkFlow =null;
      
      

      if(this.configType=="WORK_FLOW"){

         this.getworkFlowList();
         this.modalTitle ="Petition Work flow ";
          if(this.caseType && _.has(this.caseType ,"name")){
           this.modalTitle =""+this.caseType['name']+" Workflow ";
        }
        this.$modal.show('petition-workflow-configuration'); 
      }else if(this.configType=="QUESTIONNAIRE_TEMPLATE"){
        this.getQuestionnaireTemplatsList();
        
        this.modalTitle ="Petition Questionnaire template ";
        if(this.caseType && _.has(this.caseType ,"name")){
           this.modalTitle =""+this.caseType['name']+" ";
        }
          if(this.caseSubType && _.has(this.caseSubType ,"name")){
           this.modalTitle =this.modalTitle+" "+this.caseSubType['name']+" Questionnaire";
        }

        this.$modal.show('petition-workflow-configuration'); 
       
      }else  if(this.configType=="FORMS_LETTERS"){
         this.$modal.hide('petition-workflow-configuration'); 
          this.getFormsAndLetters();
          this.modalTitle ="Case Subtype Forms and letters ";

          if(this.caseSubType && _.has(this.caseSubType ,"name")){
           this.modalTitle ="Case Subtype "+this.caseSubType['name']+" Forms and letters";
        }   
      }
             
      //this.$modal.show('petition-workflow-configuration'); 

    },
    changedType(type='main'){
      //this.togleLoader(true);
      this.maintypeloader=false
      this.subtypeloader=false
      if(type=='main'){
        this.maintypeloader=true
      }
      if(type=='sub'){
        this.subtypeloader=true
      }
      setTimeout(()=> {
        //this.togleLoader(false)
        this.maintypeloader=false
        this.subtypeloader=false

      } ,300)

    },

    togleLoader(type=false){
      if(type){
        this.$vs.loading();
      }else{
         this.$vs.loading.close();
      }
     
    },
    getPetitionConfigList(index=-1) {
      this.togleLoader(true);
      
      let postData = {
          "filters":{
            "tenantIds": [], // Send only for roles 1 and 2
            "statusList": [],
            "activeList": [],
            "typeIds": [],
            "subTypeIds": [],
            "statusList": [],
            "createdDateRange": []
          },
          "page": 1, // Optional when 'getAll' send as 'true'
          "perpage": 100000000,// Optional when 'getAll' send as 'true'
          "getAll": true, // Send as 'true' to get all list
          "getByPetitionType":true
          
	};
      this.$store
        .dispatch("commonAction", { data: postData, path: "/petition-config/list" })
        .then((response) => {
           
          this.petitionConfigList = response.list;

         
            this.selectedMainTypeIndex =0;
            // if(index>-1){
            //    this.selectedMainTypeIndex =index;
            // }
            this.selectedSubTypeIndex = 0;
            
            if(this.caseType && _.has(this.caseType ,'_id' )){

              let selectedIndex =_.findIndex(this.petitionConfigList ,{"_id":this.caseType['_id']});
              if(selectedIndex>-1){
                this.selectedMainTypeIndex =selectedIndex
                this.caseType= this.petitionConfigList[selectedIndex];

                if(this.caseType && this.checkProperty(this.caseType ,'subTypes' ,'length')>0 && this.caseSubType && _.has(this.caseSubType ,'_id' )){
                  let subIndex = _.findIndex(this.caseType['subTypes'] , {"_id":this.caseSubType['_id']});
                  if(subIndex>-1){
                    this.selectedSubTypeIndex =subIndex;
                    this.caseSubType = this.caseType['subTypes'][subIndex];

                  }
                    
                }

              }
              this.selectWorkFlowConfig();
              this.selectToConfig(this.petitionConfigList[this.selectedMainTypeIndex]  ,'FORMS_LETTERS' ,null);

            }else{

              if(this.petitionConfigList && this.petitionConfigList.length>0){

                this.caseType = this.petitionConfigList[0];
                if(this.caseType && this.checkProperty(this.caseType ,'subTypes' ,'length')>0){
                  this.selectedSubTypeIndex = 0;
                  this.caseSubType = this.caseType['subTypes'][0];

                }
                this.selectWorkFlowConfig();
               this.selectToConfig(this.petitionConfigList[this.selectedMainTypeIndex]  ,'FORMS_LETTERS' ,null);

              }

            }
          //   if(this.petitionConfigList && this.petitionConfigList.length>0){
             
          //    this.selectToConfig(this.petitionConfigList[this.selectedMainTypeIndex]  ,'FORMS_LETTERS' ,null);

          //  }
            this.togleLoader(false);
            this.getQuestionnaireTemplatsList();
          
        }).catch((err)=>{
            this.togleLoader(false);
          this.showToster({ message:err,isError:true})
        })
    },

   //QUESTIONNAIRE_TEMPLATE Methods
    templateSelected(tplId){
     
      _.forEach( this.questionnaireTemplatsList ,(item)=>{
        item.selected = false;
          if(tplId ==item['_id'] ){
              item.selected = true;
              item['showLoading'] =true;
          }

       }

      );
     

    },
    getQuestionnaireTemplatsList(){
          this.editConfiguration =false;

   let  postData ={
          "filters":{},
          "getMasterData":true,
          getAll:true,
          "page":1,
          "perpage":25
          ,"sorting":{"path":"createdOn","order":-1}
        }

          this.$store.dispatch("commonAction" ,{ data:postData, path:"/questionnaire/list"})
          .then(response => {
            let tempList =[];
            let lst = response.list;
            _.forEach(lst ,(item)=>{

               if(!this.checkProperty( item , 'tenantId')){
                 item['name'] = item['name']+" (Global)"
              }
              
              item = Object.assign(item ,{"selected":false});
              item['showLoading'] =false;
            
               if(this.caseSubType && _.has(this.caseSubType ,'configDetails') && _.has(this.caseSubType['configDetails'] ,'questionnaireTplId') && this.caseSubType['configDetails']['questionnaireTplId'] == item['_id'] ){
                 item = Object.assign(item ,{"selected":true});
                 this.editConfiguration =true;
                 this.configId = this.caseSubType['configDetails']['_id'];
                
              }else if(this.caseType && _.has(this.caseType ,'configDetails') && _.has(this.caseType['configDetails'] ,'questionnaireTplId') && this.caseType['configDetails']['questionnaireTplId'] == item['_id'] ){
                 item = Object.assign(item ,{"selected":true});
                 this.editConfiguration =true;
                 this.configId = this.caseType['configDetails']['_id'];
                 
              }
              tempList.push(item);
            });
            this.questionnaireTemplatsList = tempList;
           
           
          })
          .catch((err)=>{
            
          })
    },
    
    
    //FORMS_LETTERS methods
    getFormsAndLetters(){
         
             let postData ={'page':1 ,'perpage':1000000 ,getMasterData:true};
            this.$store.dispatch("getList" ,{data:postData,path:"/form-letter/list"})
            .then(response => {
              this.formsAndLettersList =[];

              _.forEach(response.list ,(item)=>{
                if( _.has(item ,'type')){
                  if(item['type'] == 'audit_response'){

                    item['name'] = item['name']+" (Audit Response)"

                  }else{
                    
                    item['name'] = item['name']+" ("+item['type']+")"
                  }
                  
                }
                 
                 
                  item = Object.assign(item ,{"selected":false})
                  if((_.has(this.caseSubType ,'configDetails') && _.has( this.caseSubType['configDetails'] ,"_id")  )){
                       this.configId = this.caseSubType['configDetails']['_id'];
                       this.editConfiguration = true;

                       if((  _.has(this.caseSubType['configDetails'], 'formAndLetterIds') && this.caseSubType['configDetails']['formAndLetterIds'].length > 0)){
                           if(this.caseSubType['configDetails']['formAndLetterIds'].indexOf(item['_id']) >-1){
                              item = Object.assign(item ,{"selected":true});
                           }
                          
                       }
                    
                  }
                  
                  this.formsAndLettersList.push(item);
              });
            });

    },
    downloadFile(document){
       
         window.open(this.$globalgonfig._APIURL+"/common/viewfile?path="+document.path, "_blank");
    },
    

    //work flow methods
    selectWorkFlowConfig(){
      this.editConfiguration =false;
      this.selectedWorkFlow =null;
      this.configId ='';
    _.forEach(this.workFlowList ,(item)=>{
      item = Object.assign(item ,{"selected":false});
      item = Object.assign(item ,{"showLoading":false});
      //checkProperty(caseSubType ,'id') ==15
      if(this.checkProperty(this.caseType ,'id')  !=3 ){
        if( _.has(this.caseType ,'workflowConfigDetails') && _.has(this.caseType['workflowConfigDetails'] ,'workflowId') && _.has(this.caseType['workflowConfigDetails'] ,'_id')){
          if(item._id==this.caseType['workflowConfigDetails']['workflowId']){
            item = Object.assign(item ,{"selected":true});
            this.selectedWorkFlow =item;
            this.workFlowSelected(item._id);
          }
          this.configId = this.caseType['workflowConfigDetails']['_id'];
          this.editConfiguration =true
        }
    }else{
      

      
      

      if( _.has(this.caseSubType ,'workflowConfigDetails') && _.has(this.caseSubType['workflowConfigDetails'] ,'workflowId') && _.has(this.caseSubType['workflowConfigDetails'] ,'_id')){
          if(item._id==this.caseSubType['workflowConfigDetails']['workflowId']){
            item = Object.assign(item ,{"selected":true});
            this.selectedWorkFlow =item;
            this.workFlowSelected(item._id);
          }
          this.configId = this.caseSubType['workflowConfigDetails']['_id'];
          this.editConfiguration =true
        }

        
        
    }
      
    });
            
            

    },

     getworkFlowList(){
         this.configId ='';
        this.editConfiguration =false
   let  postData ={
          "filters":{},
          "getMasterData":true,
          getAll:true,
          "page":1,
          "perpage":25
          ,"sorting":{"path":"createdOn","order":-1}
        }

          this.$store.dispatch("commonAction" ,{ data:postData, path:"/workflow/list"})
          .then(response => {
            let tempList =[];
            let lst = response.list;
            _.forEach(lst ,(item)=>{
              item = Object.assign(item ,{"selected":false});
              item = Object.assign(item ,{"showLoading":false});
              if(this.checkProperty(this.caseType ,'id')  !=3 ){
                if(_.has(this.caseType ,'workflowConfigDetails') && _.has(this.caseType['workflowConfigDetails'] ,'workflowId') && _.has(this.caseType['workflowConfigDetails'] ,'_id')){
                  if(item._id==this.caseType['workflowConfigDetails']['workflowId']){
                    item = Object.assign(item ,{"selected":true});
                    this.selectedWorkFlow =item;
                    this.workFlowSelected(item._id);
                  }
                  this.configId = this.caseType['workflowConfigDetails']['_id'];
                  this.editConfiguration =true
                }
              }else{

                if(_.has(this.caseSubType ,'workflowConfigDetails') && _.has(this.caseSubType['workflowConfigDetails'] ,'workflowId') && _.has(this.caseSubType['workflowConfigDetails'] ,'_id')){
                  if(item._id==this.caseSubType['workflowConfigDetails']['workflowId']){
                    item = Object.assign(item ,{"selected":true});
                    this.selectedWorkFlow =item;
                    this.workFlowSelected(item._id);
                  }
                  this.configId = this.caseSubType['workflowConfigDetails']['_id'];
                  this.editConfiguration =true
                }

              }
              tempList.push(item);
            });
            this.workFlowList = tempList;
          
           
          })
          .catch((err)=>{
            
          })
      },
    workFlowSelected(tplId){
     
      _.forEach( this.workFlowList ,(item)=>{
        item.selected = false;
          if(tplId ==item['_id'] ){
              item.selected = true;
              this.selectedWorkFlow = item;

          }

       }

      );
     

    },

    updaQtemplate(updateAction=''){
      let _self =this;
      this.fromFromsAndLatters=false;
       this.errorMessage = '';
       let selectedTemplate = _.find( this.questionnaireTemplatsList ,{ "selected":true });
      let formsLatters = _.filter(this.formsAndLettersList ,{"selected":true});

       if(selectedTemplate && _.has(selectedTemplate ,"_id")){

          let postData  = {
              "typeId": this.caseType['id'] ,
              "questionnaireTplId":'' ,
             // "insertTo":'All',
              "formAndLetterIds":formsLatters,
              'showPetitionAlert':false,
              "active":true,
               "subTypeId":_self.checkProperty(_self.caseSubType ,'id')
              };
            postData['questionnaireTplId'] = selectedTemplate['_id'];
           
            
            let actionPath ="/petition-config/create";
            if(this.editConfiguration){
             actionPath ="/petition-config/update";
             postData  = Object.assign(postData ,{ "petitionConfigId": this.configId});
           
           }


           if(['create' ,'update'].indexOf(updateAction)>-1){
                postData =Object.assign(postData ,{"updateAction":updateAction})

              }else{
                this.updateOrCreateFormsLattersPopup =false;
                this.selectionMessage ='';
              }

              //this.checkProperty(this.caseType ,'id')

              if(this.checkProperty(this.caseSubType ,'id')  ){
                
                 postData  =Object.assign(postData , {"subTypeId":this.caseSubType['id'] });
              }

                  
            
              this.formSubmited =true;
              this.$store.dispatch("caseConfigUpdateOrCreate" ,{ data:postData, path:actionPath})
              .then((res)=>{
                 this.updateOrCreateFormsLattersPopup =false;
                this.formSubmited =false;
                this.showToster({message:res.message ,isError:false});
                this.getPetitionConfigList();
                this.hideModel();
                })
                .catch((err)=>{

                   this.updateOrCreateFormsLattersPopup =false;
                   if(this.checkProperty(err ,'code') =="LINKED_WITH_PETITION"){
                   this.updateOrCreateFormsLattersPopup =true;
                   this.selectionMessage = this.checkProperty(err ,'message');
                   this.fromFromsAndLatters=false;

                  }else{
                     this.fromFromsAndLatters=false;
                     this.errorMessage = this.checkProperty(err ,'message');
                  }

                  
                   this.formSubmited =false;
                 
              });
      }

    } ,
    workFlowconfigAction(){
      
      this.errorMessage = '';
         if((this.selectedWorkFlow !=null )  ){
           let postData  = { "petitionTypeId": this.caseType['id'] ,"active":true };
            if(this.caseType && _.has(this.caseType ,'configDetails') && _.has(this.caseType['configDetails'] ,'questionnaireTplId')  ){
             postData  =Object.assign(postData , {"questionnaireId":this.caseType['configDetails']['questionnaireTplId'] });
           }
           

          postData  =Object.assign(postData , {"workflowId":this.selectedWorkFlow['_id'] });
         // alert(this.checkProperty(this.caseSubType ,'id'));
         
          if( this.checkProperty(this.caseType ,'id') ==3  ){
            //petitionSubTypeId updaQtemplate
            postData  =Object.assign(postData , {"petitionSubTypeId":this.caseSubType['id'] });
          }

        
           let actionPath ="/workflow/config-save";
           if(this.editConfiguration ){
             actionPath ="/workflow/config-update";
             
             
              if(this.configId ){
                postData = Object.assign(postData,{"workflowConfigId":this.configId})
              }
        
           }
           this.formSubmited =true;
           this.$store.dispatch("commonAction" ,{ data:postData, path:actionPath})
           .then((res)=>{
            
             this.showToster({message:res.message ,isError:false});
             this.selectedWorkFlow =null;
             this.formSubmited =false;
              this.getPetitionConfigList();
              this.hideModel();
             
            })
           .catch((err)=>{
             this.errorMessage = err;
             this.formSubmited =false;
             // this.showToster({message:err ,isError:true});
               
           });

         }
      },
      opdateOrCreateFormsANdLetters(updateAction=''){
      this.fromFromsAndLatters=true;
        this.errorMessage = '';
       let formsLatters = _.filter(this.formsAndLettersList ,{"selected":true});
       let postData  = {
              "typeId": this.caseType['id'] ,
              "subTypeId":this.caseSubType['id'],
              "questionnaireTplId":'' ,
              "insertTo":'All',
              "formAndLetterIds":formsLatters.map((item)=>item._id),
              'showPetitionAlert':false,
              "active":true
              };
              if(['create' ,'update'].indexOf(updateAction)>-1){
                postData =Object.assign(postData ,{"updateAction":updateAction})

              }else{
                this.updateOrCreateFormsLattersPopup =false;
                this.selectionMessage ='';
              }
           
           if(this.checkProperty(this.caseSubType,'configDetails' ,'questionnaireTplId')){
             postData['questionnaireTplId'] = this.caseSubType['configDetails']['questionnaireTplId'];
            }else if(this.checkProperty(this.caseType,'configDetails' ,'questionnaireTplId')){
               postData['questionnaireTplId'] = this.caseType['configDetails']['questionnaireTplId'];

            }
            let actionPath ="/petition-config/create";
            if(this.editConfiguration){
             actionPath ="/petition-config/update";
             postData  = Object.assign(postData ,{ "petitionConfigId": this.configId});
           
           }
                  
            
              this.formSubmited =true;
              this.$store.dispatch("caseConfigUpdateOrCreate" ,{ data:postData, path:actionPath})
              .then((res)=>{
                 this.fromFromsAndLatters=false;
                this.updateOrCreateFormsLattersPopup =false
                this.formSubmited =false;
                this.showToster({message:res.message ,isError:false});
                this.getPetitionConfigList();
                this.hideModel();
                })
                .catch((err)=>{
                  
                  this.formSubmited =false;
                  this.updateOrCreateFormsLattersPopup =false
                  //this.showToster({message:err ,isError:true});
                  if(this.checkProperty(err ,'code') =="LINKED_WITH_PETITION"){
                   this.updateOrCreateFormsLattersPopup =true;
                   this.selectionMessage = this.checkProperty(err ,'message');
                    this.fromFromsAndLatters=true;

                  }else{
                     this.fromFromsAndLatters=false;
                     this.errorMessage = this.checkProperty(err ,'message');
                  }
                  
              });
      

    }, 
    
  },
  directives: {},
  components: {
    VuePhoneNumberInput,
    FileUpload,
    moment,
    Datepicker,
    InfoIcon,
    XIcon,
    MoreVerticalIcon,
    workflowActivityView,
    QuestionnaireTemplate,
   PermQuestionnaireTemplate,
   VuePerfectScrollbar,
   h4eadQuestionnaireTpl
  },
};
</script>